import { type ReactNode } from "react";

export type InlineAlertStatus = "error" | "warning" | "success";

interface InlineAlertProps {
  status?: InlineAlertStatus;
  children: ReactNode;
  className?: string;
}

const TEXT_STYLES: Record<InlineAlertStatus, string> = {
  error: "text-red",
  warning: "text-warning-alert",
  success: "text-success-alert",
};

/**
 * Shared inline message per the toast-vs-inline standard (ENG-1885):
 * errors render here, contextually near the action/field that failed.
 * Success/warning belong in a toast instead of this component.
 * Matches the existing `<Input error>` convention used app-wide — plain text, no box/icon.
 */
export const InlineAlert = ({ status = "error", children, className }: InlineAlertProps) => {
  if (!children) return null;
  return (
    <p
      role="alert"
      aria-live="polite"
      className={`text-[0.75rem] ${TEXT_STYLES[status]} ${className ?? ""}`}
    >
      {children}
    </p>
  );
};
